import * as types from '../actions/loading-actions';

const initialState = {
	show: false,
	stack: 0
};

const loadingReducer = function (state = initialState, action) {

	switch (action.type) {
		case types.SHOW_LOADING:
			return Object.assign({}, state, {
				show: true,
				stack: state.stack++
			});
			break;

		case types.HIDE_LOADING:
			let stack = state.stack--;
			return Object.assign({}, state, {
				show: Boolean(stack),
				stack: stack
			});
			break;
	}

	return state;
};

export default loadingReducer;


// WEBPACK FOOTER //
// ./src/reducers/loading-reducer.js